<template>
  <v-container>
    <div class="Rectangle-32">
      <v-sheet class="pa-12" color="white lighten-3">
        <v-sheet class="mx-auto" maxHeight="512" maxWidth="815">
          <div class="cen">
            <img
              class="img"
              src="../assets/Group.png"
              alt="teller logo"
              width="40"
              height="40"
            />
            <p class="tex display-1">Transaction Succesful</p>
            <p v-if="detail.meterToken != ''">
              Meter Token :
            </p>
            <p class="headline">{{ detail.meterToken }}</p>
            <v-btn @click="goback()" dark large class="btnn">Done</v-btn>
          </div>
        </v-sheet>
      </v-sheet>
    </div>
  </v-container>
</template>
<script>
export default {
  metaInfo: {
    title: "Teller/Successful",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  computed: {
    getRouteName() {
      return this.$store.state.AirTime.routeName;
    },
    detail() {
      return this.$store.getters.getElectDetail;
    },
  },
  methods: {
    goback() {
      if (this.getRouteName) {
        this.$router.replace({ name: "dashboard" });
        this.$store.dispatch("SetRouteName", false);
      } else {
        this.$router.go(-1);
      }
      let payload = {
        status: false,
        message: "",
      };
      this.$store.dispatch("SnackbarFunc", payload);
      this.$store.commit("setmeterToken", "");
      this.$store.commit("setDialog", false);
    },
  },
};
</script>
<style scoped>
.Rectangle-32 {
  width: 100%;
  height: 100%;
  padding-top: 90px;
  background-color: rgba(255, 255, 255, 0.97);
}
.cen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
}
.tex {
  text-align: center;
  color: #444444;
}
.img {
  width: 210.1px;
  height: 227px;
  object-fit: contain;
}
.btnn {
  width: 162px;
  height: 55px;
  border-radius: 15px;
  background-color: #9f09d7 !important;
}
</style>
